<div class="p-4 min-w-[356px] flex flex-col">
  <mat-form-field>
    <mat-chip-grid #chipList class="ml-2">
      @for (singleValue of filterValue; track singleValue) {
        <mat-chip-row
          (removed)="removeFromStringArrayFilter(singleValue)">
          <span>{{ singleValue }}</span>
          <mat-icon matChipRemove svgIcon="close"></mat-icon>
        </mat-chip-row>
      }
    </mat-chip-grid>

    <input #input
      matInput
      autofocus
      appGxInput
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addToStringArrayFilter($event)"
      (paste)="pasteIntoStringArrayFilter($event)">
  </mat-form-field>

  <div class="flex self-end">
    <button (click)="updateFilter()"
      aria-label="Apply"
          class="ag-button ag-standard-button ag-filter-apply-panel-button
               w-[fit-content]">{{ "APPLY" | translate }}
    </button>

    <button (click)="handleReset()"
      aria-label="Clear"
          class="ag-button ag-standard-button ag-filter-apply-panel-button
               w-[fit-content]">{{ "RESET" | translate }}
    </button>
  </div>
</div>

